import React, { lazy, Suspense, ComponentType } from 'react';
import { SkeletonLoader } from '../components/common/SkeletonLoader';

// Shared web component props interface
export interface WebComponentProps {
  // Arbitrary data payload passed via r2wc, can be JSON parsed upstream
  data?: unknown;
}

// Default lightweight fallback while chunk loads
export const DefaultFallback: React.FC = () => <SkeletonLoader lines={2} lineHeight={12} />;

// Factory to create a lazy component with a consistent Suspense fallback.
// T must extend WebComponentProps so `data` prop is always available.
export function createLazyComponent<
  T extends WebComponentProps = WebComponentProps
>(
  importFn: () => Promise<{ default: ComponentType<T> }>,
  fallback: React.ComponentType = DefaultFallback
) {
  const LazyInner = lazy(importFn);

  const Wrapped: React.FC<T> = (props) => (
    <Suspense fallback={React.createElement(fallback)}>
      <LazyInner {...props} />
    </Suspense>
  );
  Wrapped.displayName = 'LazyComponent';
  return Wrapped;
}